export default __webpack_public_path__ + "static/media/Selected_Training.dab9e4ab.svg";